import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AnimatedButton } from "../../../../Constant";
import { ANIMATED_BUTTON } from "../../../../Data/FormControl/CheckboxAndRadio";
import { AnimatedRadio } from "./AnimatedRadio";
import { AnimatedCheckbox } from "./AnimatedCheckbox";

const AnimatedButtons = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={AnimatedButton} span={ANIMATED_BUTTON} />
        <CardBody>
          <Row className="g-3">
            <AnimatedRadio />
            <AnimatedCheckbox />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AnimatedButtons;
